import { HttpClient } from "@angular/common/http";
import { Injectable, OnDestroy } from "@angular/core";
import { AbTipoDocumentoAdmin } from "app/abstract/full-pages/customs/tipo-documento-admin/tipo-documento-admin.abstract";
import { TipoDocumentoAdmin } from "app/models/tipo-documento-admin.model";
import { setCookieLocal, verifyCookieLocal } from "app/utils/cookie.utils";
import { of as observableOf, Observable, Subject, takeUntil } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class TipoDocumentoAdminService extends AbTipoDocumentoAdmin implements OnDestroy {

    private readonly destroy$ = new Subject();
    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public getAllByLocal(local: string): Observable<any> {
        return this.get(`admin/tipo_documento/by_local/${local}`);
    }

    public getByIntegrador(): Observable<any> {
        return this.get('admin/tipo_documento/by_integrador/');
    }

    public getByTenant(): Observable<any> {
        return this.get('admin/tipo_documento/by_tenant/');
    }

    public getByTenantId(tenantId: number): Observable<any> {
        return this.get(`admin/tipo_documento/by_tenant_id/${tenantId}`);
    }

    public getByPublicTenantId(tenantId: number): Observable<any> {
        return this.get(`public/admin/tipo_documento/by_tenant_id/${tenantId}`);
    }

    public getLocale(): Observable<any> {
        const locale = verifyCookieLocal();

        if (locale)
            return observableOf(locale);

        const ret = this.getByTenant();
        this.setCookieLocal(ret);
        return ret;

    }

    public setCookieLocal(tipoDocumentos: Observable<Array<TipoDocumentoAdmin>>) {
        tipoDocumentos.pipe(takeUntil(this.destroy$)).subscribe(td => {
            setCookieLocal(td);
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

}
